import { CUSTOM_GATEWAYS_STORAGE_KEYS } from "../localStorageKeys/custom-gateways";
import { CustomGateway } from "./types";

/**
 * Desk-only custom gateways are terminal-internal data: they live in
 * localStorage only and are never synced to any server.
 */
export const getStoredCustomGateways = (): CustomGateway[] => {
  if (typeof window === "undefined") {
    return [];
  }

  try {
    const storedData = localStorage.getItem(CUSTOM_GATEWAYS_STORAGE_KEYS.CORE);

    if (!storedData) {
      return [];
    }

    const parsedData = JSON.parse(storedData);

    if (!Array.isArray(parsedData)) {
      console.error("Invalid custom gateways data in localStorage");
      return [];
    }

    return parsedData;
  } catch (error) {
    console.error("Error loading custom gateways from localStorage:", error);
    return [];
  }
};

export const saveCustomGateways = (gateways: CustomGateway[]): void => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    localStorage.setItem(
      CUSTOM_GATEWAYS_STORAGE_KEYS.CORE,
      JSON.stringify(gateways)
    );
  } catch (error) {
    console.error("Error saving custom gateways to localStorage:", error);
  }
};
